export default "__VITE_PUBLIC_ASSET__390b6090__"